import { Input } from 'antd'
import React from 'react'
import { useCurrentTheme } from '../../../../../hooks/useCurrentTheme'
import style from './Hotkeys.module.scss'
import { getHotkeyChar } from './utils'

function HotKeyButton({ keyName, value, onPressKey, isDouble, hotkeysGroup, isDisabled, setIsDoubleKeys }) {
	const settings = useCurrentTheme()

	const hasDoubleElement = (values) =>
		values.map((value) => isDouble(value.toUpperCase(), setIsDoubleKeys)).includes(style.double)
			? style.double
			: style.single

	const valueFromSettings = settings.hotkeys[hotkeysGroup][keyName]

	const currentValue = Array.isArray(valueFromSettings) ? valueFromSettings.join(' ') : valueFromSettings.toUpperCase()

	const checkPressedKey = (event) => {
		const key = getHotkeyChar(event.nativeEvent.code)

		if (key) {
			onPressKey(keyName, key, hotkeysGroup)
		}
	}

	return (
		<Input
			className={Array.isArray(value) ? hasDoubleElement(value) : isDouble(value.toUpperCase(), setIsDoubleKeys)}
			style={{ width: '50%' }}
			defaultValue={Array.isArray(value) ? value.join(' ') : value.toUpperCase()}
			onKeyDown={checkPressedKey}
			value={currentValue}
			disabled={isDisabled}
		/>
	)
}

export default HotKeyButton
